/* tslint:disable */
/* eslint-disable */
/* @relayHash c5881249e20dd5182da53a725c3f470f */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AppQueryVariables = {};
export type AppQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"AppContainer_viewer">;
    } | null;
    readonly settings: {
        readonly auth: {
            readonly " $fragmentRefs": FragmentRefs<"AppContainer_auth">;
        };
    };
};
export type AppQuery = {
    readonly response: AppQueryResponse;
    readonly variables: AppQueryVariables;
};



/*
query AppQuery {
  viewer {
    ...AppContainer_viewer
    id
  }
  settings {
    auth {
      ...AppContainer_auth
    }
    id
  }
}

fragment AccountCompletionContainer_auth on Auth {
  integrations {
    local {
      enabled
      targetFilter {
        stream
      }
    }
  }
}

fragment AccountCompletionContainer_viewer on User {
  username
  email
  duplicateEmail
  profiles {
    __typename
  }
}

fragment AppContainer_auth on Auth {
  ...SignInContainer_auth
  ...SignUpContainer_auth
  ...AccountCompletionContainer_auth
}

fragment AppContainer_viewer on User {
  ...AccountCompletionContainer_viewer
  ...ForgotPasswordContainer_viewer
  ...LinkAccountContainer_viewer
}

fragment ForgotPasswordContainer_viewer on User {
  email
}

fragment LinkAccountContainer_viewer on User {
  duplicateEmail
}

fragment SignInContainer_auth on Auth {
  ...SignInWithOIDCContainer_auth
  ...SignInWithGoogleContainer_auth
  ...SignInWithFacebookContainer_auth
  integrations {
    local {
      enabled
      targetFilter {
        stream
      }
    }
    facebook {
      enabled
      redirectURL
      targetFilter {
        stream
      }
    }
    google {
      enabled
      redirectURL
      targetFilter {
        stream
      }
    }
    oidc {
      enabled
      redirectURL
      targetFilter {
        stream
      }
    }
  }
}

fragment SignInWithFacebookContainer_auth on Auth {
  integrations {
    facebook {
      redirectURL
    }
  }
}

fragment SignInWithGoogleContainer_auth on Auth {
  integrations {
    google {
      redirectURL
    }
  }
}

fragment SignInWithOIDCContainer_auth on Auth {
  integrations {
    oidc {
      name
      redirectURL
    }
  }
}

fragment SignUpContainer_auth on Auth {
  ...SignUpWithOIDCContainer_auth
  ...SignUpWithGoogleContainer_auth
  ...SignUpWithFacebookContainer_auth
  integrations {
    local {
      enabled
      targetFilter {
        stream
      }
      allowRegistration
    }
    facebook {
      enabled
      targetFilter {
        stream
      }
      allowRegistration
    }
    google {
      enabled
      targetFilter {
        stream
      }
      allowRegistration
    }
    oidc {
      enabled
      targetFilter {
        stream
      }
      allowRegistration
    }
  }
}

fragment SignUpWithFacebookContainer_auth on Auth {
  integrations {
    facebook {
      redirectURL
    }
  }
}

fragment SignUpWithGoogleContainer_auth on Auth {
  integrations {
    google {
      redirectURL
    }
  }
}

fragment SignUpWithOIDCContainer_auth on Auth {
  integrations {
    oidc {
      name
      redirectURL
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "redirectURL",
        "storageKey": null
    } as any), v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v3 = ({
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationTargetFilter",
        "kind": "LinkedField",
        "name": "targetFilter",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stream",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowRegistration",
        "storageKey": null
    } as any), v5 = [
        (v1 /*: any*/),
        (v2 /*: any*/),
        (v3 /*: any*/),
        (v4 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "AppQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AppContainer_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AppContainer_auth"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AppQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "username",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "duplicateEmail",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "profiles",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v0 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "kind": "LinkedField",
                                    "name": "integrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OIDCAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "oidc",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "name",
                                                    "storageKey": null
                                                },
                                                (v1 /*: any*/),
                                                (v2 /*: any*/),
                                                (v3 /*: any*/),
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoogleAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "google",
                                            "plural": false,
                                            "selections": (v5 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FacebookAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "facebook",
                                            "plural": false,
                                            "selections": (v5 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LocalAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "local",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v3 /*: any*/),
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v0 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "c5881249e20dd5182da53a725c3f470f",
            "metadata": {},
            "name": "AppQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '239c0cb30a10cf062277214f3f816f1b';
export default node;
